"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacingMixin = void 0;
var _marginMixin = require("./marginMixin");
var _mediaQueryMixin = require("./mediaQueryMixin");
var _paddingMixin = require("./paddingMixin");
var spacingMediaQueryMixin = (0, _mediaQueryMixin.mediaQueryMixin)(function (mediaProps) {
  return function (props) {
    var forwardedProps = Object.assign({}, props, mediaProps);
    return [(0, _marginMixin.marginMixin)(forwardedProps), (0, _paddingMixin.paddingMixin)(forwardedProps)];
  };
});

/** @mixin spacingMixin */
/**
 * Adds margin and padding props.
 *
 * <ul>
 *     <li><code>margin</code></li>
 *     <li><code>marginX</code></li>
 *     <li><code>marginY</code></li>
 *     <li><code>marginTop</code></li>
 *     <li><code>marginBottom</code></li>
 *     <li><code>marginLeft</code></li>
 *     <li><code>marginRight</code></li>
 *     <li><code>padding</code></li>
 *     <li><code>paddingX</code></li>
 *     <li><code>paddingY</code></li>
 *     <li><code>paddingTop</code></li>
 *     <li><code>paddingBottom</code></li>
 *     <li><code>paddingLeft</code></li>
 *     <li><code>paddingRight</code></li>
 * </ul>
 *
 * @example
 * import { spacingMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${spacingMixin}
 * `;
 *
 * <Component margin="lg" paddingX="sm" paddingTop="xs" />
 *
 * @method
 * @param {object} props
 * @param {object} props.theme - The styled-components theme object.
 * @return {CSSObject}
 */
var spacingMixin = function spacingMixin(props) {
  return [(0, _marginMixin.marginMixin)(props), (0, _paddingMixin.paddingMixin)(props), spacingMediaQueryMixin];
};
exports.spacingMixin = spacingMixin;